import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { EmployerPayload, EmployerResponse } from 'services/requests';
import { ApiError } from 'services/api.errors';
import { MutationKeys } from 'constants/mutationKeys';

export const useAddEmployer = () => {
  const queryClient = useQueryClient();

  const mutate = async (payload: EmployerPayload) => {
    const { data } = await api.createEmployer(payload);

    return data;
  };

  const mutationKey = MutationKeys.addEmployer;

  return useMutation<EmployerResponse, AxiosError<ApiError>, EmployerPayload>(
    mutationKey,
    mutate,
    {
      onSuccess: () => queryClient.invalidateQueries('employers'),
    },
  );
};
